import { useContext, useRef, useState } from "react";

import {
  Box,
  Card,
  Tooltip,
  IconButton,
  alpha,
  styled,
  Button,
  Popover,
  Grid,
  Divider,
  MenuItem,
  ListItemText,
  Stack,
  CardActionArea,
  MenuList,
  Typography,
  Link,
} from "@mui/material";
import { SidebarContext } from "src/contexts/SidebarContext";
import Logo from "./Logo";
import NavigationMenu from "./NavigationMenu";
import LanguageSwitcher from "./LanguageSwitcher";
import Notifications from "./Notifications";
import Userbox from "./Userbox";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import React from "react";
import { t } from "i18next";
import { useBottomBar } from "../../../contexts/BottomButtonsContext";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@emotion/react";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import ChevronRightTwoToneIcon from "@mui/icons-material/ChevronRightTwoTone";
import Text from "src/components/Text";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import PeopleOutlineTwoToneIcon from "@mui/icons-material/PeopleOutlineTwoTone";
import DashboardCustomizeTwoToneIcon from "@mui/icons-material/DashboardCustomizeTwoTone";
import ContactSupportTwoToneIcon from "@mui/icons-material/ContactSupportTwoTone";
import ThemeSettings from 'src/components/ThemeSettings';
const BottomBarWrapper = styled(Card)(
  ({ theme }) => `
    height: calc(${theme.header.height} - 10px);
    bottom: 0;
    color: ${theme.header.textColor};
    padding: 0;
    right: 0;
    z-index: 6;
    background: ${alpha(theme.colors.primary.main, 0.85)};
    backdrop-filter: blur(5px);
    box-shadow: none;
    position: fixed;
    justify-content: space-between;
    width: 100%;
    display: flex;
    border-radius: 0;
`
);

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: ${theme.spacing(0, 1)};
  background: ${alpha(theme.colors.alpha.black[100], 0.1)};
`
);

const NavigationMenuWrapper = styled(Box)(
  () => `
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`
);

export const IconButtonPrimary = styled(IconButton)(
  ({ theme }) => `
    display: inline-flex;
    width: 58px;
    border-radius: ${theme.general.borderRadiusLg};
    height: 58px;
    justify-content: center;
    font-size: ${theme.typography.pxToRem(13)};
    padding: 0;
    position: relative;

    .MuiSvgIcon-root {
      transition: ${theme.transitions.create(["color"])};
      font-size: ${theme.typography.pxToRem(28)};
      color: ${theme.colors.alpha.trueWhite[50]};
    }

    &.active,
    &:hover {
      background-color: ${theme.colors.alpha.black[10]};

      .MuiSvgIcon-root {
        color: ${theme.colors.alpha.trueWhite[100]};
      }
    }
`
);

export const LabelWrapper = styled(Box)(
  ({ theme }) => `
  font-size: ${theme.typography.pxToRem(10)};
  font-weight: bold;
  text-transform: uppercase;
  border-radius: ${theme.general.borderRadiusSm};
  padding: ${theme.spacing(0.5, 1, 0.4)};
`
);

export const CardActionAreaWrapper = styled(CardActionArea)(
  ({ theme }) => `
      .MuiTouchRipple-root {
        opacity: 1;
      }

      .MuiCardActionArea-focusHighlight {
        background: ${theme.colors.primary.main};
      }

      &:hover {
        .MuiCardActionArea-focusHighlight {
          opacity: .07;
        }
      }
`
);

export const MenuListWrapperSecondary = styled(MenuList)(
  ({ theme }) => `
  padding: ${theme.spacing(3)};

  & .MuiMenuItem-root {
      border-radius: 50px;
      padding: ${theme.spacing(1, 1, 1, 2.5)};
      min-width: 200px;
      margin-bottom: 2px;
      position: relative;
      color: ${theme.colors.alpha.black[70]};

      &.Mui-selected,
      &:hover,
      &.MuiButtonBase-root:active {
          background: ${theme.colors.alpha.black[10]};
          color: ${theme.colors.alpha.black[100]};
      }

      &:last-child {
          margin-bottom: 0;
      }
    }
`
);

export const MenuListWrapperSuccess = styled(MenuList)(
  ({ theme }) => `
  padding: ${theme.spacing(3)};

  & .MuiMenuItem-root {
      border-radius: 50px;
      padding: ${theme.spacing(1, 1, 1, 2.5)};
      min-width: 200px;
      margin-bottom: 2px;
      position: relative;
      color: ${theme.colors.success.main};

      &.Mui-selected,
      &:hover,
      &.MuiButtonBase-root:active {
          background: ${theme.colors.success.lighter};
          color: ${theme.colors.success.dark};
      }

      &:last-child {
          margin-bottom: 0;
      }
    }
`
);

export const MenuListWrapperError = styled(MenuList)(
  ({ theme }) => `
  padding: ${theme.spacing(3)};

  & .MuiMenuItem-root {
      border-radius: 50px;
      padding: ${theme.spacing(1, 1, 1, 2.5)};
      min-width: 200px;
      margin-bottom: 2px;
      position: relative;
      color: ${theme.colors.error.main};

      &.Mui-selected,
      &:hover,
      &.MuiButtonBase-root:active {
          background: ${theme.colors.error.lighter};
          color: ${theme.colors.error.dark};
      }

      &:last-child {
          margin-bottom: 0;
      }
    }
`
);

export const MenuListWrapperInfo = styled(MenuList)(
  ({ theme }) => `
  padding: ${theme.spacing(3)};

  & .MuiMenuItem-root {
      border-radius: 50px;
      padding: ${theme.spacing(1, 1, 1, 2.5)};
      min-width: 200px;
      margin-bottom: 2px;
      position: relative;
      color: ${theme.colors.info.main};

      &.Mui-selected,
      &:hover,
      &.MuiButtonBase-root:active {
          background: ${theme.colors.info.lighter};
          color: ${theme.colors.info.dark};
      }

      &:last-child {
          margin-bottom: 0;
      }
    }
`
);


export const DotLegend = styled("span")(
  ({ theme }) => `
    border-radius: 22px;
    width: ${theme.spacing(1.4)};
    height: ${theme.spacing(1.45)};
    display: inline-block;
    border: ${theme.colors.alpha.white[100]} solid 2px;
`
);
function BottomBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggle = (event) => {
    setIsOpen(!isOpen);
    setAnchorEl(bottomref.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };
  const bottomref = useRef(null);
  // const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { element, elementLeft } = useBottomBar();
  const theme = useTheme();
  return (
    <BottomBarWrapper ref={bottomref}>
      <MenuWrapper>
        {/* <Box>
          <IconButtonPrimary color="primary" onClick={handleToggle}>
            <MenuIcon />
            {isOpen ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </IconButtonPrimary>
        </Box> */}
          <Notifications />
        <Box
          sx={{
            ml: 1,
          }}
        >
          {elementLeft}
        </Box>

        <NavigationMenuWrapper
          sx={{
            display: { xs: "inline-block", md: "inline-block" },
          }}
        >
          <NavigationMenu  bottomref={bottomref}/>
        </NavigationMenuWrapper>
        <Box>{element}</Box>
      </MenuWrapper>
    </BottomBarWrapper>
  );
}

export default BottomBar;
